export default __webpack_public_path__ + "static/media/ic_united_states.ac6883ff.svg";